module.exports = __webpack_public_path__ + "img/ar_menu_img.4103d373.png";